import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import './ContractSignature.css';
import logo from '../assets/branding/abogados_quiroz_logo_exact.svg';

const api = () => (window.__CRM_API__ || process.env.REACT_APP_API_URL || `${window.location.origin}/api`).replace(/\/$/, '').replace(/\/api\/api$/, '/api');

export default function ContractSignature() {
  const token = window.location.pathname.split('/').filter(Boolean).pop();
  const [request, setRequest] = useState(null);
  const [name, setName] = useState('');
  const [consent, setConsent] = useState(false);
  const [state, setState] = useState({ loading: true, saving: false, error: '' });
  const signatureCanvas = useRef(null);
  const [drawing, setDrawing] = useState(false);
  const [hasHandwrittenSignature, setHasHandwrittenSignature] = useState(false);

  useEffect(() => {
    axios.get(`${api()}/public/signatures/${encodeURIComponent(token)}`)
      .then(({ data }) => { setRequest(data); setName(data.signer_name || data.contract?.recipient || ''); })
      .catch((error) => setState((current) => ({ ...current, error: error.response?.data?.detail || 'No fue posible abrir la solicitud de firma.' })))
      .finally(() => setState((current) => ({ ...current, loading: false })));
  }, [token]);

  const point = (event) => {
    const canvas = signatureCanvas.current;
    const bounds = canvas.getBoundingClientRect();
    return { x: (event.clientX - bounds.left) * (canvas.width / bounds.width), y: (event.clientY - bounds.top) * (canvas.height / bounds.height) };
  };
  const startSignature = (event) => {
    const canvas = signatureCanvas.current; if (!canvas) return;
    event.preventDefault(); canvas.setPointerCapture?.(event.pointerId);
    const context = canvas.getContext('2d'); const location = point(event);
    context.beginPath(); context.moveTo(location.x, location.y); setDrawing(true); setHasHandwrittenSignature(true);
  };
  const drawSignature = (event) => {
    if (!drawing) return; event.preventDefault();
    const context = signatureCanvas.current.getContext('2d'); const location = point(event);
    context.lineTo(location.x, location.y); context.stroke();
  };
  const stopSignature = () => setDrawing(false);
  const clearSignature = () => {
    const canvas = signatureCanvas.current; if (!canvas) return;
    canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height); setHasHandwrittenSignature(false);
  };

  const sign = async (event) => {
    event.preventDefault();
    setState({ loading: false, saving: true, error: '' });
    try {
      const signatureImage = hasHandwrittenSignature ? signatureCanvas.current?.toDataURL('image/png') : null;
      const { data } = await axios.post(`${api()}/public/signatures/${encodeURIComponent(token)}/sign`, { signer_name: name, consent, signature_image: signatureImage });
      setRequest(data);
    } catch (error) {
      setState({ loading: false, saving: false, error: error.response?.data?.detail || 'No fue posible registrar la firma.' });
      return;
    }
    setState({ loading: false, saving: false, error: '' });
  };

  if (state.loading) return <main className="signature-page"><section className="signature-card">Cargando documento seguro…</section></main>;
  if (state.error && !request) return <main className="signature-page"><section className="signature-card signature-error"><h1>Enlace no disponible</h1><p>{state.error}</p></section></main>;
  const signed = request?.status === 'signed';
  const canSign = !signed && request?.can_sign !== false;
  return <main className="signature-page"><section className="signature-card">
    <img className="signature-logo" src={logo} alt="Abogados Quiroz" />
    <p className="signature-eyebrow">FIRMA ELECTRÓNICA SEGURA</p><h1>{signed ? 'Contrato firmado' : canSign ? 'Revise y firme su contrato' : 'Enlace de firma no disponible'}</h1>
    <p className="signature-subtitle">{request.contract?.title} · {request.contract?.case_type || 'Proceso legal'}</p>
    {(signed || canSign) ? <iframe className="signature-document" title="Contrato para firma" src={`${api()}/public/signatures/${encodeURIComponent(token)}/document`} /> : <div className="signature-document-unavailable"><b>Este enlace necesita una nueva versión</b><span>{request?.document_issue || 'Solicite a Abogados Quiroz un nuevo enlace de firma.'}</span></div>}
    {signed ? <div className="signature-success"><b>✓ Firma registrada</b><span>Firmado por {request.signature_name || request.signer_name} el {new Date(request.signed_at).toLocaleString('en-US')}.</span></div> : <form onSubmit={sign} className="signature-form">
      {!canSign ? <p className="signature-inline-error">La firma se desactivó para protegerle: no firme una versión que no sea la vigente.</p> : <>
      <label>Nombre completo como firma<input required minLength="3" value={name} onChange={(event) => setName(event.target.value)} /></label>
      <section className="handwritten-signature" aria-label="Firma manuscrita opcional">
        <div><b>Firma manuscrita</b><span>Opcional: dibújela con el dedo, lápiz o mouse.</span></div>
        <canvas ref={signatureCanvas} width="1200" height="300" onPointerDown={startSignature} onPointerMove={drawSignature} onPointerUp={stopSignature} onPointerCancel={stopSignature} />
        <button type="button" className="signature-clear" onClick={clearSignature} disabled={!hasHandwrittenSignature}>Borrar firma</button>
      </section>
      <label className="signature-consent"><input required type="checkbox" checked={consent} onChange={(event) => setConsent(event.target.checked)} />Confirmo que he revisado el documento y acepto utilizar mi nombre como firma electrónica para este contrato.</label>
      {state.error && <p className="signature-inline-error">{state.error}</p>}
      <button disabled={state.saving || !consent}>{state.saving ? 'Registrando firma…' : 'Firmar digitalmente'}</button>
      <small>El CRM registra fecha, hora y evidencia técnica. Al confirmar, guarda el PDF firmado en la carpeta Contrato y Pagos del cliente.</small>
      </>}
    </form>}
  </section></main>;
}
